import React from 'react';
import { ArrowRight, Users } from 'lucide-react';
import { BusinessHero } from '@/components/ui/content-blocks';

const HeroSection = () => {
  return (
    <BusinessHero
      title="Die Köpfe hinter splusd-solutions"
      titleHighlight="Über uns"
      description="splusd-solutions ist deine Digitalisierungsberatung und Softwareentwicklung für maßgeschneiderte Lösungen, die Unternehmen erfolgreicher machen."
      details="Seit 2019 entwickelt splusd-solutions individuelle Software, E-Commerce-Plattformen und Mobile Apps für mittelständische Unternehmen. Unser Fokus liegt auf technischer Exzellenz, strategischer Beratung und langfristigen Partnerschaften."
      backgroundStyle="default"
      primaryCTA={{
        label: "Unser Team kennenlernen",
        href: "#team"
      }}
      secondaryCTA={{
        label: "Projekt besprechen",
        href: "#contact",
        icon: <ArrowRight size={16} />
      }}
    />
  );
};

export default HeroSection; 